import styled from 'styled-components'

const Strong = styled.strong`
  font-weight: 800;
`

export default Strong
